import api from './api';

const organisationService = {
  /**
   * Get the current user's organisation details.
   */
  async getMine() {
    const response = await api.get('/organisations/me');
    return response.data;
  },

  /**
   * Update the current user's organisation (name only). Admin-only on the backend.
   */
  async updateMine(orgData) {
    const response = await api.patch('/organisations/me', orgData);
    return response.data;
  },

  /**
   * Set (or update) what this organisation wants to track and mark
   * onboarding as complete. Admin-only on the backend.
   */
  async completeOnboarding({
    trackingCategories, customCategories, usesEiaCertificates, hasWorkersOnSite,
  }) {
    const response = await api.post('/organisations/me/onboarding', {
      trackingCategories, customCategories, usesEiaCertificates, hasWorkersOnSite,
    });
    return response.data;
  },
};

export default organisationService;
